/**
 * Team Member Types
 * Task 5.1: Create TeamMember TypeScript Types
 */

export type TeamRole = 'organizer' | 'event_manager' | 'host' | 'vendor_coordinator' | 'member';
export type TeamMemberStatus = 'active' | 'inactive';

export interface TeamMember {
  id: number;
  celebration_id: number;
  user_id: number;
  role: TeamRole;
  status: TeamMemberStatus;
  celebration_guest_quota?: number | null;
  created_by: number;
  created_at: string;
  updated_at: string;
}

export interface TeamMemberWithUser extends TeamMember {
  is_celebration_creator?: boolean;
  user: {
    id: number;
    full_name: string;
    email: string;
    phone?: string;
  };
}

export interface CreateTeamMemberRequest {
  user_id: number;
  role: TeamRole;
  celebration_guest_quota?: number | null;
}

export interface UpdateTeamMemberRequest {
  role?: TeamRole;
  status?: TeamMemberStatus;
  celebration_guest_quota?: number | null;
}

export interface TeamMemberPermissions {
  canEditCelebration: boolean;
  canDeleteCelebration: boolean;
  canManageTeam: boolean;
  canManageEvents: boolean;
  canManageGuests: boolean;
  canAddRemoveGuests: boolean;
  canManageVendors: boolean;
  canManageServices: boolean;
  canManageActivities: boolean;
  canCreateTasks: boolean;
  canViewAll: boolean;
}

export interface GetTeamMembersResponse {
  team_members: TeamMemberWithUser[];
}

// Role display names
export const ROLE_LABELS: Record<TeamRole, string> = {
  organizer: 'Organizer',
  event_manager: 'Event Manager',
  host: 'Host',
  vendor_coordinator: 'Vendor Coordinator',
  member: 'Member'
};

// Role descriptions
export const ROLE_DESCRIPTIONS: Record<TeamRole, string> = {
  organizer: 'Full access to all celebration features including team management',
  event_manager: 'Can manage events, guests, and tasks',
  host: 'Can add and remove guests only',
  vendor_coordinator: 'Can manage vendors and services',
  member: 'Can view celebration details and complete assigned tasks'
};

// Role colors for badges
export const ROLE_COLORS: Record<TeamRole, string> = {
  organizer: 'bg-purple-100 text-purple-800 border-purple-200',
  event_manager: 'bg-blue-100 text-blue-800 border-blue-200',
  host: 'bg-amber-100 text-amber-800 border-amber-200',
  vendor_coordinator: 'bg-green-100 text-green-800 border-green-200',
  member: 'bg-gray-100 text-gray-800 border-gray-200'
};
